module.exports = __webpack_public_path__ + "static/people_img7-55ba482b2f93ad636020f0827fef0a38.png";